export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const LOGOUT = 'LOGOUT';

export const loginSuccess = (data: any) => ({
  type: LOGIN_SUCCESS,
  payload: data,
});

export const updateProfile = (data: any) => ({
  type: UPDATE_PROFILE,
  payload: data,
});

export const logout = () => ({
  type: LOGOUT,
});